import { OrderStakeholderType } from '../../types';
import { INSPECTIFY_PHONE_NUMBER } from '../../constants';

const rejectedEmails = [
  'hello+',
  '@inspectify.com'
];
export const hideStakeholder = (stakeholder: OrderStakeholderType) => !!(
  stakeholder.isClient && stakeholder.name
  || (!stakeholder.email
    && stakeholder.phone === INSPECTIFY_PHONE_NUMBER
    && rejectedEmails.includes(stakeholder.email || '')
  )
);
